module.exports = __webpack_public_path__ + "img/progress.e61ebbe6.webp";